import { render, staticRenderFns } from "./Coverage.vue?vue&type=template&id=54fc966c&scoped=true&"
import script from "./Coverage.vue?vue&type=script&lang=js&"
export * from "./Coverage.vue?vue&type=script&lang=js&"
import style0 from "./Coverage.vue?vue&type=style&index=0&id=54fc966c&lang=scss&scoped=true&"
import style1 from "./Coverage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fc966c",
  null
  
)

export default component.exports